export default __webpack_public_path__ + "2bd87912f40c1195254561b3567013ce.jpg";